import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
} from 'reactstrap';

import Grid from '../../components/cms/grid';
import ModelService from '../../services/feedback.service';

const initCriteria = {
  id: '',
  name: '',
  email: '',
  phone: '',
  company: '',
  industry: '',
  url: '',
  message: '',
  status: '',
  order: 'desc',
  sortBy: 'created_at',
};

const Feedbacks = ({ t, getColumns }) => (
  <div className="">
    <Row>
      <Col xl={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-envelope-o" /> {t('Feedbacks')}</strong>
          </CardHeader>
          <CardBody>
            <Grid id="feedbacks" service={ModelService} columns={getColumns(t)} initCriteria={initCriteria} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

Feedbacks.propTypes = {
  t: PropTypes.func.isRequired,
  getColumns: PropTypes.func.isRequired,
};

export default Feedbacks;



// WEBPACK FOOTER //
// ./src/views/feedbacks/Feedbacks.jsx